export default "__VITE_ASSET__Bh0owz3T__"